export default "__VITE_ASSET__96195ff2__"